<div class="container container-tip">
  <app-tip-radio-group [items]="items" [flexEndCss]="flexEndCss" [selectedEnd]="isShowCustomTipTextbox" [(ngModel)]="selectedTip"
                       (selectItem)="selectTip()" (selectEnd)="selectCustomTip()">
    <ng-template let-item #item>
      <div>
        <div>{{formatTip(item)}}</div>
      </div>
    </ng-template>
    <ng-template #end let-checked="checked" let-hover="hover">
      <div class="custom-tip">
        <div class="custom-tip__label">{{currencySign}}</div>
        <div class="custom-tip__input-container">
          <input
            #customTip
            currencyMask
            autocomplete=”false”
            type="tel"
            max="500"
            min="0"
            [class.custom-tip__input--selected]="showCustomTipSelectedStyle(checked, hover)"
            (focus)="focusCustomTip()"
            (blur)="blurCustomTip()"
            (keyup)="onCustomAmountChange($event)"
            [(ngModel)]="customAmount"
            [options]="{ align: 'center', allowNegative: false, precision: 2, prefix: '' }"
            placeholder="0.00" class="custom-tip__input"/>
        </div>
      </div>
    </ng-template>
  </app-tip-radio-group>
  <p class="custom-amount-input-err-msg" *ngIf="errorMessage">
    {{ errorMessage }}
  </p>
</div>
